export default class ModalCadencierUnique extends HTMLDivElement {

    constructor() {
        super();

        this.submitButton = this.querySelector('.modal-footer button');
        this.catalogueId = this.submitButton.dataset.catalogueId;
        this.currentModal = this;
    }

    connectedCallback() {
        this.addExceptionalDelivery();
    }

    addExceptionalDelivery() {
        if (this.submitButton) {
            this.submitButton.addEventListener('click', (event) => {
                event.preventDefault();

                // On récupère la date sélectionnée du DatePanel react du button .b-date
                const selectedDate = this.querySelector('.b-date');

                if (selectedDate) {
                    // On récupère le contenu HTML de la balise (qui correspond à la date format FR)
                    const dateText = selectedDate.textContent.trim();
                    // On convertit la date au format YYYY-MM-DD pour l'envoyer au back
                    const dateParts = dateText.split('/');
                    if (dateParts.length === 3) {
                        const formattedDate = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`;
                        selectedDate.value = formattedDate; // On ajoute une propriété value à l'élément avec la date formatée
                    } else {
                        selectedDate.value = null;
                    }

                    if (selectedDate) {
                        // On ajoute la date exceptionnelle
                        const url = this.submitButton.dataset.updateRoute;
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                            },
                            body: JSON.stringify({
                                datas_updated: { [selectedDate.value]: { delivery_date: selectedDate.value, is_exceptional: true } },
                            }),
                        })
                            .then(response => response.json())
                            .then(data => {
                                this.refreshTemplates(data.templates);

                                const zoneRemove = document.querySelector(`[data-catalogue-id="${this.catalogueId}"] .remove-exceptional-delivery`);
                                if (zoneRemove) {
                                    const parentCard = zoneRemove.closest('.card-dates-delivery');
                                    if (parentCard) {
                                        parentCard.querySelector('.p-3').innerHTML = `
                                            <div class="radio-card date">
                                                <input type="radio" name="radio-card-${this.catalogueId}" id="dex-${this.catalogueId}" value="${selectedDate.value}" data-exceptional="1" checked="">
                                                <label for="dex-${this.catalogueId}">
                                                    <strong>${new Date(selectedDate.value).toLocaleDateString('fr-FR', { weekday: 'long' })}</strong>
                                                    ${new Date(selectedDate.value).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
                                                </label>
                                            </div>`;

                                        parentCard.classList.remove('hide');

                                        // ⭐ reinit du composant pour capter les nouveaux radios & le bouton remove
                                        parentCard.reinit?.();
                                    }
                                }

                                // fermer la modal
                                this.currentModal.querySelector('button.btn-close')?.click();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    }
                }
            });
        }
    }

    refreshTemplates(templates) {
        if (typeof templates === 'object') {
            for (const [name, content] of Object.entries(templates)) {
                if (typeof content !== 'string') { return; }
                const els = document.querySelectorAll(`[data-cart-template="${name}"]`);
                for (const el of els) {
                    el.innerHTML = content;
                }
            }
        }
    }
}
